var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.33571V2.25M9 15.75V12.6643M12.6643 9H15.75M2.25 9H5.33571M11.5913 6.40909L13.7732 4.22716M4.22655 13.7731L6.40848 11.5911M11.5913 11.5909L13.7732 13.7728M4.22655 4.22693L6.40848 6.40886",
    stroke: "#FAFAFA",
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLoadingIcon);
export default __webpack_public_path__ + "static/media/AiLoadingIcon.e916d2b0ab5d41d7e993592d72244683.svg";
export { ForwardRef as ReactComponent };